import { Component, OnInit, HostListener, ElementRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Language } from 'src/app/model/language';
import { LANGUAGE_LIST } from 'src/app/model/mockup/language-mockup';
import { PublicService } from '../service.service';
import { GetAllPublicProjectsResponse } from '../public-project-response';

@Component({
  selector: 'app-initial-page',
  templateUrl: './initial-page.component.html',
  styleUrl: './initial-page.component.css'
})
export class InitialPageComponent implements OnInit, OnDestroy {
  languageOptions: Language[];
  selectedLanguage: Language;
  
  public projects: GetAllPublicProjectsResponse[] = [];
  public loadingProjects = true;
  public isMenuOpen = false;
  public scrolled = false;
  
  // Car animation
  public isExploding = false;
  
  // Gauge animation
  public gaugeValue = 0;
  private gaugeInterval: any;

  constructor(
    private router: Router,
    private translocoService: TranslocoService,
    private publicService: PublicService,
    private el: ElementRef
  ) {
    this.languageOptions = LANGUAGE_LIST as [];
    this.selectedLanguage = this.languageOptions[0];
  }

  ngOnInit(): void {
    this.loadProjects();
    this.initScrollReveal();
    this.startGaugeAnimation();
    
    const savedLang = sessionStorage.getItem('language');
    if (savedLang) {
      const lang = this.languageOptions.find(l => l.name === savedLang);
      if (lang) this.selectedLanguage = lang;
    }
  }

  ngOnDestroy(): void {
    if (this.gaugeInterval) {
      clearInterval(this.gaugeInterval);
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 50;
    this.checkReveal();
  }

  loadProjects() {
    this.loadingProjects = true;
    this.publicService.getAllPublicProjects(1, null).subscribe({
      next: (res) => {
        this.projects = (res.listItens ?? []).slice(0, 4);
        this.loadingProjects = false;
      },
      error: () => {
        this.loadingProjects = false;
      }
    });
  }

  initScrollReveal() {
    setTimeout(() => this.checkReveal(), 100);
  }

  checkReveal() {
    const reveals = this.el.nativeElement.querySelectorAll('.reveal');
    for (let i = 0; i < reveals.length; i++) {
      const windowHeight = window.innerHeight;
      const elementTop = reveals[i].getBoundingClientRect().top;
      const elementVisible = 150;
      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add('active');
      }
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  changeLanguage(lang: Language) {
    this.selectedLanguage = lang;
    this.translocoService.setActiveLang(lang.name);
    sessionStorage.setItem('language', lang.name);
  }

  login() {
    this.router.navigate(['/login']);
  }

  signUp() {
    this.router.navigate(['/create-account']);
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      this.isMenuOpen = false;
    }
  }

  // Car explosion animation
  explode() {
    this.isExploding = true;
    setTimeout(() => {
      this.isExploding = false;
    }, 2000);
  }

  // Gauge animation
  startGaugeAnimation() {
    let direction = 1;
    this.gaugeInterval = setInterval(() => {
      this.gaugeValue += direction * 2;
      if (this.gaugeValue >= 100) {
        direction = -1;
      } else if (this.gaugeValue <= 0) {
        direction = 1;
      }
    }, 100);
  }
}
